// ssn-product-grid.js — variant/pack picker + real Add to Cart for every
// [data-ssn-card] on the page (Festive Essentials grid and Combos grid
// both use this same script since they share the same card markup).
document.addEventListener('DOMContentLoaded', function () {
  function addToCart(variantId, button) {
    if (!variantId || !button || button.disabled) return;
    button.disabled = true;
    var isMainButton = button.hasAttribute('data-ssn-addtocart');
    var labelEl = isMainButton ? button.querySelector('[data-ssn-add-label]') : null;
    var originalLabel = button.dataset.label || (labelEl ? labelEl.textContent : button.textContent);
    if (labelEl) labelEl.textContent = '...';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || 'Could not add to cart');

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: res.data }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: res.data }));

        if (isMainButton) {
          if (labelEl) labelEl.textContent = button.dataset.addedLabel || 'Added ✓';
          button.classList.add('is-added');
        } else {
          button.style.transform = 'scale(1.15)';
          setTimeout(function () { button.style.transform = ''; }, 250);
        }

        if (button.dataset.afterAdd === 'go_to_cart') {
          window.location.href = root + 'cart';
          return;
        }

        setTimeout(function () {
          button.disabled = false;
          if (isMainButton) {
            if (labelEl) labelEl.textContent = originalLabel;
            button.classList.remove('is-added');
          }
        }, 1800);
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        if (labelEl) labelEl.textContent = 'Try Again';
        button.disabled = false;
        setTimeout(function () { if (labelEl) labelEl.textContent = originalLabel; }, 1800);
      });
  }

  document.querySelectorAll('[data-ssn-card]').forEach(function (card) {
    var variantBtns = card.querySelectorAll('[data-ssn-variant]');
    var addBtn = card.querySelector('[data-ssn-addtocart]');
    var quickAddBtn = card.querySelector('[data-ssn-add]');
    var priceEl = card.querySelector('[data-ssn-price]');
    var badgeEl = card.querySelector('[data-ssn-badge]');
    var savingsEl = card.querySelector('[data-ssn-savings]');

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        variantBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var vid = btn.getAttribute('data-variant-id');
        if (addBtn) addBtn.setAttribute('data-variant-id', vid);
        if (quickAddBtn) quickAddBtn.setAttribute('data-variant-id', vid);
        if (priceEl) {
          var onSale = btn.getAttribute('data-onsale') === 'true';
          var priceHtml = btn.getAttribute('data-price-html');
          var compareHtml = btn.getAttribute('data-compare-html');
          priceEl.innerHTML = priceHtml + (onSale ? '<span class="ssn-card__strike">' + compareHtml + '</span>' : '');
        }
        if (badgeEl) {
          var isOnSale = btn.getAttribute('data-onsale') === 'true';
          var offPct = btn.getAttribute('data-off') || '0';
          if (isOnSale && offPct !== '0') {
            var badgeStyle = badgeEl.getAttribute('data-badge-style');
            badgeEl.textContent = (badgeStyle === 'percentage') ? (offPct + '% OFF') : 'SALE';
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
        if (savingsEl) {
          var savingsHtml = btn.getAttribute('data-savings-html');
          if (savingsHtml) {
            savingsEl.textContent = savingsHtml;
            savingsEl.style.display = '';
          } else {
            savingsEl.style.display = 'none';
          }
        }
      });
    });

    if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn.getAttribute('data-variant-id'), addBtn); });
    if (quickAddBtn) quickAddBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(quickAddBtn.getAttribute('data-variant-id'), quickAddBtn); });
  });
});
